import React from 'react';
import {Button} from "@mui/material";
import styles from '../../assets/styles/modules/Error400.module.css'
import logo from '../../assets/images/2digit_color_logo.png'

const Error400 = () => {
    return (
        <div className='container'>
            <div className='inner_container'>
                <div className={styles.error_container}>
                        <img className={styles.logo} alt="logo" src={logo}/>
                        <h1 className={styles.title}>원하시는 페이지를 찾을 수 없습니다.</h1>
                        <p className={styles.sub_title}>
                            {`찾으려는 페이지의 주소가 잘못 입력되었거나, 
                            주소의 변경 혹은 삭제로 인해 사용하실 수 없습니다.
                            입력하신 페이지의 주소가 정확한지 다시 한번 확인해 주세요.`}
                        </p>
                        <Button variant='outlined' className={styles.btn}>메인으로 이동</Button>
                </div>
            </div>
        </div>
    );
};

export default Error400;